module.exports = __webpack_public_path__ + "static/img/图层 34.65c9c38f.png";